import { render, staticRenderFns } from "./rpage.vue?vue&type=template&id=0972e20a&scoped=true&"
import script from "./rpage.vue?vue&type=script&lang=js&"
export * from "./rpage.vue?vue&type=script&lang=js&"
import style0 from "./rpage.vue?vue&type=style&index=0&id=0972e20a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0972e20a",
  null
  
)

export default component.exports